import { APIFactory } from '../../ui-toolkit/rest/APIFactory';
import { UUID } from '../../types/shared/UUID';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';
import { axiosErrorHandler } from '../../ui-toolkit/rest/axiosErrorHandler';

export const removeConversationOrderAsync = async (args: { orderId: UUID; genesysId: UUID }): Promise<void> =>
  APIFactory(baseUrlService.ApiLocation)
    .delete(`/timber/api/internal/orders/${args.orderId}/conversations/${args.genesysId}`)
    .then(() => void 0)
    .catch(axiosErrorHandler);
